import vueUpdateArray from 'common/vueUpdateArray';
import {MutationTree} from "vuex";
import {ExpertRatingsState} from "../types/ExpertRatingsState";
import Vue from 'vue';

interface RatingQuery {
    sectionId: string;
    projectId: string;
    criteriaIndex: number;
    value: number;
}

export const mutations: MutationTree<ExpertRatingsState> = {
    setSections(state, data) {
        state.sections = data;
        state.isLoaded = true;
    },
    addProfile(state, data) {
        state.profiles.push(data);
    },
    setSelected(state, value: string) {
        state.selected = value;
        if (!value) {
            state.canSaveCurrentSectionRates = false;
            state.currentSectionRatesSaved = false;
        }
    },
    resetIsLoaded(state) {
        state.isLoaded = false;
    },
    setCriterias(state, data) {
        state.criterias = data;
    },
    setSectionProjects(state, data) {
        state.sectionProjects = data;
    },
    setAdditionalCriteria(state, data) {
        Vue.set(state.additionalCriterias, data.index, {
            title: data.value === "null" ? null : data.value,
            orderIndex: 8 + data.index
        });
    },
    setAdditionalCriterias(state, data) {
        state.additionalCriterias = [];

        data.forEach((criteria: string, index: number) => {
            Vue.set(state.additionalCriterias, index, {
                title: criteria,
                orderIndex: 8 + index
            });
        });
    },
    setSectionRatings(state, data) {
        state.ratings[data.sectionId] = data.ratings;
    },
    setProjectRating(state, data: RatingQuery) {
        Vue.set(state.ratings[data.sectionId][data.projectId], data.criteriaIndex, data.value);
    },
    setCanRateCurrentSection(state, value: boolean) {
        state.canSaveCurrentSectionRates = value;
    },
    setPosition(state, { id, position }) {
        const projectIndex = state.sectionProjects.findIndex(project => project.id === id);
        if (projectIndex !== -1) {
            state.sectionProjects[projectIndex].speakingOrder = position;
        }
    },
    setCurrentSectionRatesSaved(state, value: boolean) {
        state.currentSectionRatesSaved = value;
    },
    setExpertSummaryRatings(state, data: Record<string, Record<string, number>>) {
        for (let projectId in data) {
            let sum = 0;
            let count = 0;

            for (let expertId in data[projectId]) {
                if (!Object.prototype.hasOwnProperty.call(state.summaryExpertRatings, projectId)) {
                    Vue.set(state.summaryExpertRatings, projectId, {});
                }
                if (!Object.prototype.hasOwnProperty.call(state.summaryExpertRatings[projectId], expertId)) {
                    Vue.set(state.summaryExpertRatings[projectId], expertId, 0);
                }

                Vue.set(state.summaryExpertRatings[projectId], expertId, data[projectId][expertId]);
                count++;
                sum += data[projectId][expertId];
            }

            Vue.set(state.summaryProjectRatings, projectId, count === 0
                ? 0
                : sum / count);
        }
    },
    setExpertSummaryComments(state, data) {
        for (let projectId in data) {

            for (let expertId in data[projectId]) {
                if (!Object.prototype.hasOwnProperty.call(state.summaryExpertsComments, projectId)) {
                    Vue.set(state.summaryExpertsComments, projectId, {});
                }

                Vue.set(state.summaryExpertsComments[projectId], expertId, data[projectId][expertId]);
            }
        }
    },
    setExpertComment(state, data) {
        if (!Object.prototype.hasOwnProperty.call(state.comments, data.expertId)) {
            state.comments[data.expertId] = {};
        }

        state.comments[data.expertId][data.projectId] = data.value;
    },
    setSummaryComment(state, { projectId, value }) {
        state.summaryComments[projectId] = value;
    },
    updateSection(state, data) {
        const index = state.sections.findIndex(localSection => localSection.id === data.section.id);
        if (index !== -1) {
            Vue.set(state.sections, index, data.section);

            const additionalCriterias: (object | null)[] = [];
            [0, 1, 2].forEach(index => {
                if (data.section && data.section?.additionalRatingCriterias && data.section.additionalRatingCriterias[index]) {
                    additionalCriterias[index] = { title: data.section.additionalRatingCriterias[index]};
                } else {
                    if (data.isChairman) {
                        additionalCriterias[index] = { title: null};
                    }
                }
            })

            Vue.set(state, 'additionalCriterias', additionalCriterias);
        }
    }
}
